import { Popover } from '@base-ui/react/popover'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface PopoverTitleProps extends PartProps<Popover.Title.Props> {
  className?: string
}

function PopoverTitle({ className, children, ...props }: PopoverTitleProps) {
  return (
    <Popover.Title className={twMerge('text-md text-foreground font-medium', className)} {...props}>
      {children}
    </Popover.Title>
  )
}

export { PopoverTitle }
